import React from 'react';
import PropTypes from 'prop-types';
import AddPaymentModal from '../AddPaymentModal';
import WithVendorBankingCheck from '../WithVendorBankingCheck';

const AddPaymentWithBankingCheck = ({
  modalProps
}) => (
  <WithVendorBankingCheck
    ModalComponent={AddPaymentModal}
    modalProps={modalProps}
  />
)

AddPaymentWithBankingCheck.propTypes = {
  modalProps: PropTypes.object
}

export default AddPaymentWithBankingCheck;
